export default "__VITE_ASSET__BOdEBzng__"